﻿import { mutations } from "@/graphql";
import { useState } from "react";
import { useMutation } from "@apollo/client/react";
export const useUpdateSubscription = (
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) => {
  const [success, setSuccess] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  const [updateSubscriptionPlan, { loading, data }] = useMutation<any>(
    mutations.updateSubscriptionPlan,
    {
      onCompleted: (response) => {
        if (response.updateSubscriptionPlan?.success) {
          setSuccess(true);
          setResetForm(true);
          setTimeout(() => {
            setSuccess(false);
            setResetForm(false);
          }, 5000);
          onCompleted();
        } else {
          setSuccess(false);
        }
      },
      onError: ({ message }) => {
        setSuccess(false);
        onError(message);
      },
    },
  );
  return {
    updateSubscriptionPlan,
    loading,
    success,
    data,
    resetForm,
  };
};
